import Swiper from "swiper/bundle";

import "swiper/css/bundle";

export const initSlideshows = () => {
	// initialize swiper slideshows
	initSwiper();
};

const initSwiper = () => {
	if (document.querySelectorAll(".swiper").length > 0) {
		document.querySelectorAll(".swiper").forEach((swiperEl) => {
			const swiper = new Swiper(swiperEl, {
				direction: "horizontal",
				effect: "slide",
				loop: true,
				spaceBetween: 110,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				on: {
					init: function () {
						updateSlideCounter(this);
					},
					slideChange: function () {
						updateSlideCounter(this);
					},
				},
			});
		});
	}

	const iconsColumnSwiperElements = document.querySelectorAll(".icons-column-swiper");
	if (iconsColumnSwiperElements.length > 0) {
		iconsColumnSwiperElements.forEach((el) => {
			let iconsColumnInit = false;
			let iconsColumnSwiper;
			const handleIconsColumnResize = () => {
				if (window.innerWidth < 768 && !iconsColumnInit) {
					console.log("initializing icons column swiper");
					iconsColumnSwiper = new Swiper(el, {
						direction: "horizontal",
						effect: "slide",
						loop: true,
						spaceBetween: 20,
						slidesPerView: 1,
						pagination: {
							el: ".swiper-pagination",
							clickable: true,
						},
						navigation: {
							nextEl: ".swiper-button-next",
							prevEl: ".swiper-button-prev",
						},
						breakpoints: {
							320: {
								slidesPerView: 1,
							},
							555: {
								slidesPerView: 2,
							},
						},
						on: {
							init: function () {
								updateSlideCounter(this);
							},
							slideChange: function () {
								updateSlideCounter(this);
							},
						},
					});
					iconsColumnInit = true;
				} else if (window.innerWidth >= 768 && iconsColumnInit) {
					console.log("destroying icons column swiper");
					iconsColumnSwiper.destroy();
					iconsColumnSwiper = null;
					iconsColumnInit = false;
				}
			};
			handleIconsColumnResize();
			window.addEventListener("resize", handleIconsColumnResize);
		});
	}

	const inTheMediaSlider = new Swiper(".in-the-media-swiper", {
		direction: "horizontal",
		effect: "slide",
		loop: true,
		autoplay: {
			delay: 8500,
		},
		speed: 1275,
		slidesPerView: 3,
		spaceBetween: 36,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
			},
			555: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
		},
		on: {
			init: function () {
				updateSlideCounter(this);
			},
			slideChange: function () {
				updateSlideCounter(this);
			},
		},
	});
};

function updateSlideCounter(swiperInstance) {
	const currentEl = swiperInstance.el.querySelector(".swiper-slide-current");
	const totalEl = swiperInstance.el.querySelector(".swiper-slide-total");
	if (currentEl && totalEl) {
		currentEl.textContent = swiperInstance.realIndex + 1;
		totalEl.textContent = swiperInstance.slides.length - swiperInstance.loopedSlides * 2;
	}
}
